import { defineMessages } from 'react-intl';

export default defineMessages({
  actions: {
    id: 'sentinel.components.actionsPanel.actionsCaps',
    defaultMessage: 'Actions',
  },
  createAction: {
    id: 'sentinel.components.actionsPanel.createAction',
    defaultMessage: 'Create Action',
  },
});



// WEBPACK FOOTER //
// ./src/components/ActionsPanel/messages.js